export interface ICharges {
  id?: number;
  minAmount?: number | null;
  dcharges?: number | null;
  hcharges?: number | null;
  cityId?: number | null;
  pincode?: number | null;
  donations?: number | null;
}

export const defaultValue: Readonly<ICharges> = {};
